(() => {
  const selectors = [
    '#reviews',
    '[id*="review"]',
    '.jdgm-rev-widg',
    '.fera-allReviews',
    '.spr-reviews',
    '[data-reviews]'
  ];

  function findReviewsTarget() {
    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) return element;
    }
    return null;
  }

  function buildReviewSummary() {
    const productInfo = document.querySelector('.m-main-product .m-product-info--wrapper');
    if (!productInfo) return;

    const imageBlock = productInfo.querySelector('.main-product__block-image');
    if (!imageBlock || imageBlock.dataset.raReviewSummaryReady === 'true') return;

    imageBlock.dataset.raReviewSummaryReady = 'true';
    imageBlock.innerHTML = `
      <button type="button" class="ra-product-review-summary" aria-label="Vai alle recensioni verificate">
        <span class="ra-product-review-summary__stars" aria-hidden="true">★★★★★</span>
        <span class="ra-product-review-summary__score">4,8</span>
        <span class="ra-product-review-summary__separator" aria-hidden="true">·</span>
        <span class="ra-product-review-summary__text">Più di 10.000 recensioni verificate</span>
      </button>
    `;

    const button = imageBlock.querySelector('.ra-product-review-summary');
    button?.addEventListener('click', () => {
      const target = findReviewsTarget();
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  document.addEventListener('DOMContentLoaded', buildReviewSummary);
  document.addEventListener('shopify:section:load', buildReviewSummary);
})();
